/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostMemoryVoiceSignedurlRequest
 */
export interface PostMemoryVoiceSignedurlRequest {
    /**
     * 
     * @type {string}
     * @memberof PostMemoryVoiceSignedurlRequest
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof PostMemoryVoiceSignedurlRequest
     */
    fileExtension: string;
    /**
     * 
     * @type {string}
     * @memberof PostMemoryVoiceSignedurlRequest
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof PostMemoryVoiceSignedurlRequest
     */
    oneTimePassword: string;
}

/**
 * Check if a given object implements the PostMemoryVoiceSignedurlRequest interface.
 */
export function instanceOfPostMemoryVoiceSignedurlRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "fileExtension" in value;
    isInstance = isInstance && "contentType" in value;
    isInstance = isInstance && "oneTimePassword" in value;

    return isInstance;
}

export function PostMemoryVoiceSignedurlRequestFromJSON(json: any): PostMemoryVoiceSignedurlRequest {
    return PostMemoryVoiceSignedurlRequestFromJSONTyped(json, false);
}

export function PostMemoryVoiceSignedurlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostMemoryVoiceSignedurlRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'fileExtension': json['fileExtension'],
        'contentType': json['contentType'],
        'oneTimePassword': json['oneTimePassword'],
    };
}

export function PostMemoryVoiceSignedurlRequestToJSON(value?: PostMemoryVoiceSignedurlRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'fileExtension': value.fileExtension,
        'contentType': value.contentType,
        'oneTimePassword': value.oneTimePassword,
    };
}

